import React, { Component } from 'react';

import Noticia from './Noticia';

import {Link} from 'react-router-dom';

import { Element } from 'react-scroll';

import axios from 'axios';

export default class Noticias extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      noticias: []
    }

  }

  componentDidMount = () => {
    this.loadNoticias();
  }

  loadNoticias = async () => {

    let res = {};
    try {
      res = await axios.get("/api/noticiasEventos", {
        params: {
          'type': "NOTICIA",
          'limit': 3
        },
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.log(error);
    }

    let noticias = res.data.arrayNoticiaEventos;

    this.setState({ noticias: noticias });
  }



  render() {

    const items = this.state.noticias.map(function(item){
      return <Noticia noticia={item} key={item.title}></Noticia>;
    });

    return (
      <section>
        <Element name="noticiasElement"></Element>
        <h1>Notícias e Projetos</h1>


        {items.length === 0 ? (
          <div className="container">
            <p>Não existem notícias ou projetos na aldeia.</p>
            <p>Mas não quer dizer que estejamos parados.</p>
          </div>
        ) : (
          <div className="container">
            <div className="row">
              {items}
            </div>
            <div className="see-more">
              <Link to={'/noticias_e_eventos'}>Mais notícias<i className="fas fa-angle-right"></i></Link>
            </div>
        </div>
        )}

        
      </section>
    )
  }
}
